import React from "react";
import HeroBanner from "components/Marketing/Components/HeroBanner";
import Footer from "components/Footer";
import FeatureGrid from "./FeatureGrid";
import { BUTTON_TAGS } from "utils/constants/ui";
import LogoConnection from "components/LogoConnection";
import PATHS from "utils/paths";
import Link from "next/link";
import { isServer } from "utils/view";
import IconLink from "components/IconLink";
import ShortLinkCopy from "components/ShortLinkCopy";
import { useViewport } from "utils/context";
import { getShortLinkCheckoutUrl } from "utils/shortLink";
import { urlWithCurrentLocationCancel } from "utils/route";
import { ENV } from "utils/constants/env";
import { getConfig } from "utils/env";
import InfoNotice from "components/InfoNotice";
import { magicCheckoutStyles } from "components/Landing/MagicCheckout/magicCheckoutStyles";
import { landingStyles } from "components/Landing/landingStyles";
import { cellGrow } from "constants/styles";
import ContentCTA from "../Components/ContentCTA";

const MarketingDigitalContent = ({
  shortLinkId = getConfig("PRICE_BLOCS_DIGITAL_CONTENT_SHORT_LINK_ID")
}) => {
  const heroProps = {
    header: [
      {
        copy: "Sell your"
      },
      {
        classes: "color-primary underline",
        copy: "digital content"
      },
      {
        copy: "with payment links."
      }
    ],
    action: {
      tag: BUTTON_TAGS.LINK,
      href: PATHS.SIGNUP,
      copy: "Signup",
      classes: {
        button:
          "fw6 br2 pa3 border-box input-reset ba bg-transparent pointer f4 dib link items-center flex flex-shrink-0 cell-grow"
      }
    },
    paddingBottom: 20,
    subheader:
      "Upload a file, and we'll send your customer a link to download it after a successful payment."
  };

  const checkoutUrl = getShortLinkCheckoutUrl({
    id: shortLinkId,
    test: true,
    mode: ENV.TEST
  });
  const withCancelUrl = urlWithCurrentLocationCancel(checkoutUrl);
  const { isSmall } = useViewport();

  return (
    <div className="w-100 relative">
      <div className="mw8 center">
        <HeroBanner {...heroProps} />
        <div className="pb3">
          <Link href={PATHS.SIGNUP}>
            <div className="pointer cell-grow">
              <LogoConnection src="/assets/priceblocs_digitalContent.png" />
            </div>
          </Link>
        </div>
        <div className="pa3 pb5 flex flex-row">
          <FeatureGrid />
        </div>
      </div>
      <ContentCTA
        {...{
          header: {
            title: "Digital Content Payment Link",
            body: ["Complete checkout and we'll email you a demo file."]
          },
          subheader: (
            <div className="f5 pt3 pb1 tc black-70">
              Pay with this test card number{" "}
            </div>
          ),
          action: (
            <div className="w-100">
              <div className="justify-center items-center w-100 flex pt2">
                <div style={{ width: 190 }}>
                  <InfoNotice copy={`4242 4242 4242 4242`} />
                </div>
              </div>
              {!isServer() && (
                <div className="flex flex-column flex-row-ns items-center justify-center pt3">
                  <div className="pb3 pb0-ns">
                    <IconLink
                      href={withCancelUrl}
                      copy="Try it"
                      icon={isSmall ? "downArrow" : "rightArrow"}
                    />
                  </div>
                  <ShortLinkCopy id={shortLinkId} test />
                </div>
              )}
            </div>
          )
        }}
      />
      <div className="mw8 center">
        <div className="pt5 hairline-1 bt">
          <Footer />
        </div>
      </div>
      <style jsx>{magicCheckoutStyles}</style>
      <style jsx>{landingStyles}</style>
      <style jsx>{cellGrow}</style>
    </div>
  );
};

export default MarketingDigitalContent;
